import React from 'react';
import classNames from 'classnames';
import CategoryGroup from './../category-group';
import data from '../../utils/data';

export default class Form extends React.Component {

  static propTypes = {
    searchHandler: React.PropTypes.func.isRequired,
    categoryClickHandler: React.PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.state = {
      showingCategoryFilter: false,
    };
  }

  componentDidMount() {
    this.queryInput = this.input;
  }

  toggleFilters() {
    this.setState({
      showingCategoryFilter: !this.state.showingCategoryFilter,
    });
  }

  handleCategoryClick(category) {
    this.props.categoryClickHandler(category);
    this.setState({ showingCategoryFilter: false });
  }

  render() {
    const { showingCategoryFilter } = this.state;
    return (
      <form onSubmit={e => this.props.searchHandler(e)}>
        <div className="content form">
          <div className="grid-md-5-6">
            <input
              ref={i => (this.queryInput = i)}
              type="text"
              className="input"
              placeholder="Search influencers by name or keyword"
            />
          <div className="line md-hidden" />
          </div>
          <div className="grid-md-1-6 toogle">
            <button type="button" onClick={() => this.toggleFilters()}>
              categories
              <img src="/icons/chevron-down.svg" alt="categories" className={classNames(['arrow'], { open: showingCategoryFilter })} />
            </button>
          </div>
        </div>
        {showingCategoryFilter &&
          <div className='parent'>
            <div className="group-wrapper">
              <div className="group content">
                <div className="grid-md-5-6" />
                <div className="grid-md-1-6">
                  <div className="arrow-up" />
                </div>
                { Object.keys((data.categories || {})).map(group =>
                  <CategoryGroup
                    key={group}
                    items={data.categories[group]}
                    group={group}
                    clickHandler={category => this.handleCategoryClick(category)}
                  />,
                  )
                }
              </div>
            </div>
          </div>
        }
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search-form/index.js